import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const DollarIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M11.7959 10.5129C11.7959 12.0216 10.7901 13.0818 9.526 13.5032V14.3653C9.526 14.9176 9.07828 15.3653 8.526 15.3653H8.18813C7.63585 15.3653 7.18813 14.9176 7.18813 14.3653V13.5575C6.29104 13.2857 5.44833 12.674 4.7959 11.6546L6.33182 10.2274C6.84833 11.0702 7.50075 11.5459 8.18036 11.5459C8.91434 11.5459 9.41726 11.2061 9.41726 10.4857C9.41726 9.0177 5.12211 9.76526 5.12211 6.29924C5.12211 4.81769 6.03279 3.78468 7.18813 3.34973V2.36526C7.18813 1.81298 7.63585 1.36526 8.18813 1.36526H8.526C9.07828 1.36526 9.526 1.81298 9.526 2.36526V3.29536C10.3551 3.5672 11.1299 4.17885 11.7415 5.18468L10.2056 6.61187C9.82502 5.76915 9.14541 5.26623 8.53376 5.26623C7.89493 5.26623 7.40561 5.59245 7.40561 6.28566C7.40561 7.72644 11.7959 7.11478 11.7959 10.5129Z"
		/>
	</svg>
))
